module.exports = "/_next/static/images/dk-c0cd63470ccdd66eb1b70437c4897d2e.svg";